module.exports = __webpack_public_path__ + "static/cover-56f9aee077afe5c3e97d7105f2f5dc9f.jpg";